import _navigationTypes from './modules/navigation/types'
import _spinnerTypes from './modules/spinner/types'

export const SPINNER_TYPES = _spinnerTypes
export const NAVIGATION_TYPES = _navigationTypes
